<template>


    <app-layout :title="__('Campaign')">


        <div class="h-full">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8 h-full">


                <div class="grid grid-cols-2"
                    style="grid-template-rows:  max-content minmax(200px, max-content);">


                    <div class="flex">

                        <h1 class="my-4 text-2xl font-nexa text-dark-blue h-[30px]">

                            Campaign: {{ campaign_rule.name }}

                        </h1>


                        <a class="p-2 my-3 ml-4 bg-dark-blue items-center flex cursor-pointer w-max"
                           @click.prevent="$inertia.visit( route('campaign_rules') );">


                            <font-awesome-icon
                                class="mr-1 ml-2 text-white cursor-pointer"
                                style="width: 16px; height: 16px;"
                                size="sm"
                                :icon="['fas', 'arrow-left']" />


                            <h1 class="text-sm ml-1 font-nexa text-white cursor-pointer"
                                style="line-height: 1.5rem">

                                {{ __('Back to Campaign') }}

                            </h1>


                        </a>


                    </div>


                    <NordenTable
                        :headers="campaign_headers"
                        :rows="campaigns" >

                        <template #preview="props">

                            <div class="flex">

                                <div class="mr-4"
                                     v-for="language of languages">

                                    <img :src="`/images/flag-${language.letter_code}.png`"
                                         class="rounded-full cursor-pointer h-[20px] w-[20px]"
                                         alt="Flag"
                                         width="20"
                                         height="20"
                                         @click="handle_click_on_preview(props.row, language.id)"
                                    />

                                </div>


                            </div>


                        </template>


                    </NordenTable>


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";

export default defineComponent({

    components: {
        NordenTable,
        AppLayout,
    },

    props: {
        content_type: {
            type: String,
            default: 'Content'
        },
        campaigns: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: `The Nordic Council's environmental award`,
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da',
                            'no',
                            'fi',
                            'se',
                            'en'
                        ]
                    },
                    {
                        id: 2,
                        name: `The Nordic Council's environmental award`,
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da',
                            'fi',
                            'en'
                        ]
                    },
                    {
                        id: 3,
                        name: `The Nordic Council's environmental award`,
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da'
                        ]
                    },
                    {
                        id: 4,
                        name: 'Welcome new subscribers',
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da'
                        ]
                    },
                    {
                        id: 5,
                        name: 'Remind to update preferences',
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da'
                        ]
                    },
                    {
                        id: 6,
                        name: 'New Simple',
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da'
                        ]
                    },
                    {
                        id: 7,
                        name: 'New Extended',
                        sent: '11/11/2021 - 10:32:23',
                        opens: '43%',
                        clicks: '4.1%',
                        sent_to: '2194',
                        external_link: [
                            'da'
                        ]
                    },
                ];
            }
        },
        campaign_rule: {
            type: Object,
            default: () => {
                return {
                    mailable_class: 'App\\Mail\\NewsletterSimpleMailable',
                    name: 'Simple',
                    sent: '12/12',
                    opens: 33,
                    clicks: 12,
                    sent_to: 90
                }
            }
        },
        languages: {}
    },

    data() {
        return {
            campaign_headers: [
                {
                    name: 'Title',
                    text_key: 'name',
                    value_key: 'name',
                    column_width: 4,
                    class: 'truncate',
                },
                {
                    name: 'Content Start',
                    text_key: 'content_start',
                    value_key: 'content_start',
                    column_width: '150px',
                    class: '',
                },
                {
                    name: 'Content End',
                    text_key: 'content_end',
                    value_key: 'content_end',
                    column_width: '150px',
                    class: '',
                },
                {
                    name: 'Sent',
                    text_key: 'sent',
                    value_key: 'sent',
                    column_width: '150px',
                    class: '',
                },
                {
                    name: 'Content',
                    text_key: 'content_count',
                    value_key: 'content_count',
                    column_width: '60px',
                    class: '',
                },
                {
                    name: 'Subs',
                    text_key: 'subscribers_count',
                    value_key: 'subscribers_count',
                    column_width: '60px',
                    class: '',
                },
                {
                    name: 'Prep / Send / Sent',
                    text_key: 'sent_to',
                    value_key: 'sent_to',
                    column_width: '145px',
                    class: '',
                },
                {
                    name: 'Opens',
                    text_key: 'opens',
                    value_key: 'opens',
                    column_width: '60px',
                    class: '',
                },
                {
                    name: 'Clicks',
                    text_key: 'clicks',
                    value_key: 'clicks',
                    column_width: '60px',
                    class: '',
                },
                {
                    name: 'Preview',
                    text_key: 'preview',
                    type: 'slot',
                    value_key: 'preview',
                    column_width: '220px',
                    class: '',
                }
            ]
        }
    },


    methods: {

        status_as_text(status) {

            if ( status === 'active' ) {

                return this.__('Active');

            }
            if ( status === 'paused' ) {

                return this.__('Paused');

            }

            return this.__('No status');

        },


        handle_click_on_preview(row, language_id) {

            switch (this.campaign_rule.mailable_class) {

                case 'App\\Mail\\NewsletterSimpleMailable':

                    this.type = 'simple'

                    break;

                case 'App\\Mail\\NewsletterExtendedMailable':

                    this.type = 'extended'

                    break;

                case 'App\\Mail\\NewsletterCompactMailable':

                    this.type = 'compact'

                    break;

                case 'App\\Mail\\NewsletterWelcomeMailable':

                    this.type = 'welcome'

                    break;

                case 'App\\Mail\\NewsletterUpdatePreferenceMailable':

                    this.type = 'update'

                    break;



            }

            window.open(
                this.route('newsletter_preview', {
                    type: this.type,
                    language_id: language_id,
                    campaign_id: row.id,
                })
                , '_blank'
            );

        },


        handle_click_on_external_link() {

            alert('click event');

        },

    }

})
</script>


